import { createContext, useContext } from 'react';

export interface IStreamContext {
  startStream: (data: { threadId: string; message: string; draftQuiz?: any }) => void;
  abortStream: () => void;
  // Wraps the createThread dispatch so an abandoned call (e.g. dialog closed
  // before the response arrives) is aborted instead of resolving later and
  // leaking a stale threadId/draftQuiz into whatever session is active by
  // then via the shared quizAgent slice.
  startThread: (data: { quizId?: string; quizType?: string; draftQuiz?: any }) => Promise<any>;
}

export const StreamContext = createContext<IStreamContext | null>(null);

export const useStream = () => {
  const ctx = useContext(StreamContext);
  if (!ctx) {
    throw new Error('useStream must be used within StreamProvider');
  }
  return ctx;
};
